// https://observablehq.com/@d3/color-schemes?collection=@d3/d3-scale-chromatic

// To test a color, click a color scale, and paste the clipboard content into this function
// to reduce the number of "too similar" colors returned.
//
// function reduceSimilarColors (colors, mod = 16) {
//     const final = []
//     for (let i = 0; i < colors.length; i++) {
//         if (i % mod === 0) {
//             final.push(colors[i])
//         }
//     }
//     return final
// }

export const COOL = [
    '#23171b',
    '#493eaf',
    '#446aee',
    '#3295f7',
    '#26bde1',
    '#29ddbb',
    '#40f392',
    '#66fd6d',
    '#96fa50',
    '#c6eb3b',
    '#eed02d',
    '#ffab24',
    '#ff801d',
    '#ee5415',
    '#c92d0c',
    '#a11202'
]

export const WARM = [
    '#6e40aa',
    '#873eb1',
    '#a13db3',
    '#ba3cb0',
    '#d33ea7',
    '#e8429a',
    '#f9488a',
    '#ff5276',
    '#ff5e63',
    '#ff6e50',
    '#ff8040',
    '#fd9334',
    '#eea82f',
    '#debc30',
    '#ccd038',
    '#bce247'
]

export const RAINBOW = [
    '#6e40aa',
    '#d33ea7',
    '#ff5e63',
    '#eea82f',
    '#adf05a',
    '#3ef375',
    '#1ac6c4',
    '#437be0'
]

export const SPECTRAL = [
    '#9e0142',
    '#c02749',
    '#db494a',
    '#ee6a49',
    '#f88e53',
    '#fcb368',
    '#fed382',
    '#feeb9f',
    '#faf8b0',
    '#edf8a7',
    '#d4ee9f',
    '#b0dfa1',
    '#87cea5',
    '#60b6ab',
    '#4595b4',
    '#4771b0'
]
